export default {"src":"/_next/static/media/linkedin.7c5b68a9.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};